module.exports = __webpack_public_path__ + "img/46.6a226632.svg";